import { Controller } from "@hotwired/stimulus"

// Combo composition builder: the remote product picker dispatches
// `ui--searchable-select:committed`; each pick appends a component row cloned
// from the <template>, carrying a product[component_ids][] hidden input so the
// composition submits with the product form. The catalog is never fully
// loaded — same search-to-add pattern as the invoice item builder.
export default class extends Controller {
  static targets = ["list", "template", "empty"]

  add(event) {
    const { value, data } = event.detail
    if (!this.listTarget.querySelector(`[data-combo-id="${value}"]`)) {
      const html = this.templateTarget.innerHTML
        .replaceAll("__ID__", value)
        .replaceAll("__NAME__", data.name)
        .replaceAll("__PRICE__", `${Number(data.price).toLocaleString("vi-VN")}₫`)
      this.listTarget.insertAdjacentHTML("beforeend", html)
      this.emptyTarget.hidden = true
    }
    // Clear the picker so the next search starts fresh.
    this.application.getControllerForElementAndIdentifier(event.target, "ui--searchable-select")?.reset()
  }

  // Already-added components vanish from the dropdown. Runs on the picker's
  // `rendered` event, after each fetch.
  filterAdded(event) {
    const options = event.target.querySelectorAll("[data-ui--searchable-select-target=option]")
    let visible = 0
    options.forEach((option) => {
      option.hidden = !!this.listTarget.querySelector(`[data-combo-id="${option.dataset.value}"]`)
      if (!option.hidden) visible++
    })
    const empty = event.target.querySelector("[data-ui--searchable-select-target=empty]")
    if (empty) empty.hidden = visible > 0
  }

  remove(event) {
    event.currentTarget.closest("li").remove()
    const rows = this.listTarget.querySelectorAll("[data-combo-id]").length
    this.emptyTarget.hidden = rows > 0
  }
}
